import * as Sentry from "@sentry/react";
import type { TourConfig, TourId } from "./types";
import { validateTourConfig } from "./validate-tour-config";
import { welcomeTour } from "./welcome-tour";
import { settingsTour } from "./settings-tour";
import { quickStartTour } from "./quick-start-tour";

const _rawRegistry = {
    welcome: welcomeTour,
    settings: settingsTour,
    "quick-start": quickStartTour,
} satisfies Record<TourId, TourConfig>;

// Validate all tour configs at import time. In DEV, throw to fail fast.
// In production, remove invalid configs so they can't be started from the Help Menu.
export const tourRegistry = Object.fromEntries(
    (Object.entries(_rawRegistry) as [TourId, TourConfig][]).filter(([, config]) => {
        try {
            validateTourConfig(config);
            return true;
        } catch (e) {
            if (import.meta.env.DEV) throw e;
            console.error(`[Tours] Invalid tour config "${config.id}" — removed from registry:`, e);
            Sentry.captureException(e, { extra: { tourId: config.id, context: "tour-config-validation" } });
            return false;
        }
    }),
) as Partial<Record<TourId, TourConfig>>;
